import { FC } from 'react'
import { PoiSearch } from './PoiSearch.tsx'
import { TagFilter } from '@/js/editor/components/filter/TagFilter.tsx'
import { Tag } from '@/js/editor/components/general/Tag.tsx'
import { useSearch } from '@/js/editor/hooks/useSearch.ts'

export const PoiFilter: FC = () => {
    const { activeTags, filter, search, query } = useSearch()

    return (
        <div className={'flex-col'}>
            <div className={'flex flex-row justify-between items-center pb-3 gap-3 px-5'}>
                <PoiSearch search={search} query={query} />

                <TagFilter activeTags={activeTags} filter={filter} />
            </div>

            <div className={'flex flex-row align-middle space-x-2 px-5 pb-3 overflow-y-auto'}>
                {activeTags.map((tag) => {
                    return (
                        <Tag
                            title={tag.name}
                            key={tag.name}
                            icon={'minus'}
                            action={() => {
                                filter(tag)
                            }}
                        />
                    )
                })}
            </div>
        </div>
    )
}
